export const feeAsset = ''

export const withdrawalFeeETH = '0.00063'



// WEBPACK FOOTER //
// ./src/js/const/fees.const.js